module.exports = __webpack_public_path__ + "assets/img/yyindex-3.a9e71020.png";